import Constants from 'expo-constants'

/**
 * This allows us to get host ip when running a development build
 * In other cases EXPO_PUBLIC_API_URL needs to point to a correct host IP/domain
 */
export const getImageUrl = (src?: string) => {
  if (!src) {
    return src
  }
  const env = process.env.EXPO_PUBLIC_API_URL
  if (!Constants.debugMode || !env) {
    return src
  }
  if (!env.includes('localhost') || !src.includes('localhost')) {
    return src
  }
  if (!Constants.expoConfig?.hostUri) {
    return src
  }
  const ip = Constants.expoConfig.hostUri.split(':')[0]
  return src.replace('localhost', ip)
}
